import { render, staticRenderFns } from "./ActivityWordSearch.vue?vue&type=template&id=11dfd97c&scoped=true"
import script from "./ActivityWordSearch.vue?vue&type=script&lang=ts"
export * from "./ActivityWordSearch.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWordSearch.vue?vue&type=style&index=0&id=11dfd97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dfd97c",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWordSearch.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports